import * as React from 'react';
import { ArrowLeft24Regular } from '@fluentui/react-icons';
import { useBaseNavigation } from './NavigationContext';
import { Button } from '../../../components/Button';

const BackButton = () => {
  const { goBack, canGoBack } = useBaseNavigation();

  if (!canGoBack) return null;

  return (
    <Button
      icon={<ArrowLeft24Regular />}
      appearance="transparent"
      onClick={goBack}
    />
  );
};

export default BackButton;
